import { render, staticRenderFns } from "./MapaStatus.vue?vue&type=template&id=1b87f911"
import script from "./MapaStatus.vue?vue&type=script&lang=js"
export * from "./MapaStatus.vue?vue&type=script&lang=js"
import style0 from "./MapaStatus.vue?vue&type=style&index=0&id=1b87f911&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b87f911')) {
      api.createRecord('1b87f911', component.options)
    } else {
      api.reload('1b87f911', component.options)
    }
    module.hot.accept("./MapaStatus.vue?vue&type=template&id=1b87f911", function () {
      api.rerender('1b87f911', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MapaStatus.vue"
export default component.exports